import { CSSProperties, useState } from 'react';

import pageLayoutStyles from '@collab/layouts/PageLayout/PageLayout.module.css';
import { usePageOffset } from '@collab/providers/PageOffsetProvider';
import { useScrollDirection } from '@vcc-www/hooks';

import styles from './StickyTitleHeader.module.css';

const StickyTitleHeader: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { titleOffset } = usePageOffset();
  const isSticky = useStickyCategory();

  return (
    <div
      className={`${styles.wrapper} ${pageLayoutStyles.pageLayout}`}
      style={{ '--top': `${titleOffset}px` } as CSSProperties}
    >
      <div className={`${styles.innerWrapper}  ${isSticky ? styles.show : ''}`}>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};

const useStickyCategory = () => {
  const [isSticky, setIsSticky] = useState(false);
  const { scrollDirection } = useScrollDirection({
    offsetThreshold: 1,
    onChange: () => setIsSticky(scrollDirection === 'up'),
  });

  return isSticky;
};

export default StickyTitleHeader;
